import SumsumApi from '@/api/SumsumApi';

const state = {
  supermarketSummary: {},
};

const getters = {
  benchmarkType(state) {
    return (state.supermarketSummary && state.supermarketSummary.benchmarkType) || 'none';
  },
  improvement(state) {
    if (state.supermarketSummary) {
      return (state.supermarketSummary.supermarketAverage - state.supermarketSummary.nextMonthGoal);
    }
    return 0;
  },
};

const actions = {
  async fetchSupermarketSummary({ commit }) {
    const supermarketSummary = await SumsumApi.getSupermarketSummary();
    if (supermarketSummary) {
      commit('setSupermarketSummary', { supermarketSummary });
    }
  },
};

const mutations = {
  setSupermarketSummary(state, { supermarketSummary }) {
    state.supermarketSummary = supermarketSummary;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
